import { render } from "./Footer.vue?vue&type=template&id=d586b65e&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "@/assets/css/Footer.scss?vue&type=style&index=0&id=d586b65e&lang=scss&scoped=true"

import exportComponent from "/builds/legand/anomyma/commerce-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d586b65e"]])

export default __exports__